const PREFIX = 'ACCOUNT_BILLING_INFO_';

export const GET_BILLING_INFO = `${PREFIX}GET_BILLING_INFO`;
export const SET_BILLING_INFO = `${PREFIX}SET_BILLING_INFO`;
export const UPDATE_BANK_ACCOUNT = `${PREFIX}UPDATE_BANK_ACCOUNT`;